module.exports = __webpack_public_path__ + "media/images/iconSocialX__errorRed--dark-3f0f1f37b35215f4370460d1f3c5523f.png";